var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5628 9.50317C12.0921 9.78288 11.5516 9.93138 11 9.93138C10.4484 9.93138 9.90786 9.78288 9.43643 9.5016L0 3.90967V14.0642C0 15.3607 1.05286 16.4214 2.35714 16.4214H19.6429C20.9471 16.4214 22 15.3607 22 14.0642V3.90967L12.5628 9.50317Z",
    fill: "#A9A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1577 8.28614C10.4122 8.43779 10.7022 8.51714 10.9992 8.51714C11.2962 8.51714 11.5869 8.437 11.8399 8.28693L21.9905 2.27071C21.9442 1.01514 20.9165 0 19.642 0H2.35631C1.08188 0 0.0541696 1.01514 0.0078125 2.27071L10.1577 8.28614Z",
    fill: "#A9A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEmailIcon);
export default __webpack_public_path__ + "static/media/ProfileEmailIcon.02b0ec555a9bd2da5f89b703bfefff04.svg";
export { ForwardRef as ReactComponent };